import React, { Component } from "react";
import { Container } from "reactstrap";
import NavMenu from "./NavMenu";
import { Login } from "./screens/Login";
import MainSite from "./screens/MainSite";
import { ResetLogin } from "./screens/PasswordResetScreen";
import { getQueryStringVariable, isNullOrEmpty } from "./Util";

export class Layout extends Component {
	static displayName = Layout.name;

	render() {
		var isLoginScreen = document.location.pathname.includes("login");
		var isLogoutScreen = document.location.pathname.includes("logout");
		var isResetScreen = document.location.pathname.includes("passwordchange") && !isNullOrEmpty(getQueryStringVariable("id"));
		var auth = document.cookie.includes("dynamicAuth");
		if (isLogoutScreen && auth) {
			document.cookie = "dynamicAuth=;expires=Thu, 01 Jan 1970 00:00:01 GMT";
			document.location.href = "login";
		}

		return !isLoginScreen && !isLogoutScreen && !isResetScreen && auth ? (
			<div style={{ height: "100%", display: "flex", backgroundColor: "#ebebeb" }}>
				<NavMenu />
				<Container style={{ flex: 1, maxWidth: "none", display: "flex", padding: "4px" }}>{this.props.children}</Container>
			</div>
		) : isLoginScreen ? (
			<div style={{ height: "100%" }}>
				<Login></Login>
			</div>
		) : isResetScreen ? (
			<ResetLogin></ResetLogin>
		) : (
			<MainSite></MainSite>
		);
	}
}
